import React from 'react'
// components
import TableManagementProvider from 'containers/Search/layers/BL'
import PowerBIReportsAPI from 'containers/PowerBIReports/layers/API/index'
import PowerBIReports from 'components/PageComponents/Settings/PowerBI'

const PowerBIReportsContainer: React.FC = () => (
  <TableManagementProvider>
    <PowerBIReportsAPI>
      <PowerBIReports />
    </PowerBIReportsAPI>
  </TableManagementProvider>
)

export default PowerBIReportsContainer
